module.exports = __webpack_public_path__ + "img/soft-bg-5.62afa9c9.png";